module.exports = __webpack_public_path__ + "img/9-5.ce7b3330.png";